<template lang="pug">
  .tilt-card
    .shadow
    //.notify(v-if="notify")
      img(src="~assets/notify.png")      
    .tilt(ref="tilt")
      .card(ref="card" :class="active? 'active':''" @click="onClick" @mousedown="onmousedown" @mouseup="onmouseup")
        img(:src="img")
      .notify_event(v-if="notify_event" v-html="tips") 
      .copy
        .cn {{copy.cn}}
        .en {{copy.en}}
</template>

<script>
import { mapState } from 'vuex'
import VanillaTilt from 'src/libs/vanilla-tilt'
import Axios from 'axios'
export default {
  name: 'TiltCard',
  props: {
    img: {},
    copy: {},
    // notify: {
    //   default: false,
    // },
    // resed: {
    //   default: false,
    // },
    notify_event:{
      default: false
    },
  },
  data() {
    return {
      active: false,
      tips: null,
      onlineBooking:false
    }
  },
  computed: {
    ...mapState('app', ['appStatus']),
  },
  mounted() {
    //Gyro.on(Gyro.Events.UPDATE, this._onGyroUpdate)
    VanillaTilt.init(this.$refs.tilt, {
      max: 10,
      speed: 400,
      //glare: true,
    })
    if (this.notify_event) {
      Axios.get(`/tips.json?v=${new Date().getTime()}`).then(res=>{
        this.tips = res.data.tips
        this.onlineBooking = res.data.onlineBooking
        if (!this.onlineBooking) {
          this.copy.cn = ''
          this.copy.en = ''
        }
      })
    }
  },
  methods: {
    onClick() {
       if(!this.onlineBooking && !this.copy.en ) {return false}
      console.log('--')
      //this.active = true
      this.$emit('clicked')
    },
    // _onGyroUpdate(evt) {
    //   console.log(evt)
    // },
    onmousedown() {
      this.active = true
    },
    onmouseup() {
      this.active = false
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.tilt-card
  width: 100%
  height: 100%
  .notify
    width: pxToRem(670*1.1)
    height: pxToRem(82*1.1)
    top: pxToRem(-120)
    left: 0
    position: absolute
    img
      margin-left: pxToRem(-50)
      width: 100%
      height: 100%
      object-fit: contain
  .tilt
    -webkit-touch-callout: none
    position: relative
    width: 100%
    height: 100%
    border-radius: pxToRem(16)
    transform-style: preserve-3d
    box-shadow: 0 pxToRem(20) pxToRem(60) pxToRem(-10) rgba(59, 74, 92, 0.7), 0 pxToRem(40) pxToRem(90) 0 rgba(22, 139, 255, 0.2), pxToRem(2) pxToRem(10) pxToRem(25) pxToRem(-10) rgba(22, 139, 255, 0.5)
    //-webkit-mask-image: -webkit-radial-gradient(white, black);
    .card
      width: 100%
      height: 100%
      overflow: hidden
      transform-origin: center
      transition: transform 0.1s $easeOutCubic
      border-radius: pxToRem(16)
      //box-shadow: 0 20px 70px -10px rgba(51, 51, 51, 0.7), 0 50px 100px 0 rgba(51, 51, 51, 0.2)
      -webkit-mask-image: -webkit-radial-gradient(white, black)
      -webkit-touch-callout: none

      img
        -webkit-touch-callout: none
        transition: transform 0.1s $easeOutCubic
        transform-origin: center
        position: relative
        left: -2.5%
        top: -2.5%
        width: 105%
        height: 105%
      &.active
        transition: transform 0.2s cubic-bezier(0.075, 0.02, 0.165, 1)
        transform: scale(1.03)
        img
          transition: transform 0.2s cubic-bezier(0.075, 0.02, 0.165, 1)
          transform: scale(0.955)
    .copy
      pointer-events: none
      color: #fff
      position: absolute
      left: pxToRem(35)
      bottom: pxToRem(31)
      transform: translateZ(20px)
      .cn
        font-size: 20px
        font-family: $ff-number-big
        text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
      .en
        margin-top: 0
        font-size: 12px
        font-family: $ff-number-big
        padding-left: 1px
        font-weight: 300
        text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)  
    .notify_event
      position: absolute
      color: white
      left: pxToRem(35)
      top: pxToRem(31)
      font-size: pxToRem(28)
      text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)  
</style>
